module.exports = __webpack_public_path__ + "img/SupercommanderFA.042ab873.png";